import { Accordion, AccordionDetails, AccordionSummary, Box, Card, Stack, Typography } from "@mui/material";
import { currencyFormat } from "../utils/currencyFormat";
import { payments } from "../utils";
import { useNavigate } from "react-router-dom";

const RenderChildren = ({ children, onClick }) => {
  return (
    <Stack sx={{ mx: 1 }}>
      {children.map((c) => (
        <Box
          onClick={onClick}
          key={c.id}
          sx={{
            display: "flex",
            py: 0.8,
            justifyContent: "space-between",
            borderBottom: "1px solid #efefef",
            "&:hover": {
              background: "#efefef",
            },
          }}
        >
          <Typography sx={{ fontSize: 12 }}>{c.name}</Typography>
          <img src={c.image} alt={c.image} style={{ width: 50, border: "1px solid #efefef", borderRadius: 2 }} />
        </Box>
      ))}
    </Stack>
  );
};

const RenderNode = ({ onClick }) => {
  return (
    <>
      {payments.map((v, idx) => {
        return (
          <Accordion key={idx}>
            <AccordionSummary expandIcon={<i className="fa-solid fa-chevron-down"></i>}>
              <Typography fontSize={14} fontWeight="600">
                {v.name}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <RenderChildren onClick={onClick}>{v.children}</RenderChildren>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
};

const PaymentMethod = () => {
  const navigation = useNavigate();

  return (
    <Card sx={{ margin: "auto", maxWidth: 600, my: 3, mb: 8 }}>
      <Typography sx={{ textAlign: "center", width: "100%", p: 1.5, fontSize: 14 }}>Wirasana - Payment</Typography>
      <Box sx={{ p: { xs: 2, sm: 3 }, backgroundColor: "#f7f7f7" }}>
        <Box
          sx={{
            border: "1px solid #ccc",
            p: 2,
            mb: 2,
            borderRadius: 2,
            backgroundColor: "#fff",
          }}
        >
          <Typography>TOTAL PAYMENT</Typography>
          <Typography mt={1} color="#f5272b" fontWeight="600" fontSize={16}>
            {currencyFormat(200000)}
          </Typography>
        </Box>
        <Typography mb={0.5} fontSize={13}>
          Choose Payment method
        </Typography>
        <RenderNode onClick={() => navigation("/e-wallet")} />
      </Box>
    </Card>
  );
};

export default PaymentMethod;
